import { Directive, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[skyTooltip]',
})
export class SkyTooltipDirective {
  @Input() public tooltipLabel = '';
  @Input('skyTooltip') public enabled = true;

  public tooltipWidth = 200;

  private _tooltipWrapper!: HTMLDivElement;

  constructor(private readonly _host: ElementRef) {}

  @HostListener('mouseover')
  public onMouseOver() {
    if (!this.enabled) {
      return;
    }

    this._tooltipWrapper = this.createTooltipWrapper();
    this.appendTooltipOnCorrectPosition();
  }

  @HostListener('mouseout')
  public onMouseOut() {
    if (!this.enabled) {
      return;
    }

    this._tooltipWrapper.remove();
  }

  @HostListener('window:scroll')
  public onWindowScroll() {
    if (this._tooltipWrapper) {
      this._tooltipWrapper.remove();
    }
  }

  private createTooltipWrapper() {
    const tooltip = document.createElement('div');
    const wrapper = document.createElement('div');

    tooltip.classList.add('sky-tooltip');
    tooltip.style.width = this.tooltipWidth + 'px';
    tooltip.innerHTML = this.tooltipLabel;
    tooltip.style.zIndex = '1000000';

    wrapper.classList.add('fixed', 'z-1005', 'top-0');
    wrapper.append(tooltip);

    return wrapper;
  }

  //TODO: handle overflow top - tooltip on bottom
  private appendTooltipOnCorrectPosition() {
    const host: HTMLElement = this._host.nativeElement;
    const tooltip = this._tooltipWrapper.firstChild as HTMLDivElement;

    document.body.append(this._tooltipWrapper);

    const hostRect = host.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    if (document.body.clientWidth < hostRect.x + this.tooltipWidth / 2) {
      this.setLeftTooltipCoords(tooltipRect.height, hostRect, tooltip);
    } else {
      if (hostRect.x - this.tooltipWidth / 2 > 0) {
        this.setTopTooltipCoords(tooltipRect, hostRect, tooltip);
      } else {
        // overflow x, show on right
        const offset = tooltipRect.height - hostRect.height;
        tooltip.style.top = `${(hostRect.y - offset / 2).toFixed(0)}px`;
        tooltip.style.left = `${(hostRect.x + this.tooltipWidth + hostRect.width).toFixed(0)}px`;
      }
    }
  }

  private setTopTooltipCoords(tooltipRect: DOMRect, hostRect: DOMRect, tooltip: HTMLDivElement) {
    const offset = tooltipRect.width - hostRect.width;
    tooltip.style.left = `${(hostRect.x - offset / 2).toFixed(0)}px`;
    tooltip.style.top = `${(hostRect.y - tooltipRect.height).toFixed(0)}px`;
  }

  // private setRightTooltipCoords() {}

  private setLeftTooltipCoords(tooltipHeight: number, hostRect: DOMRect, tooltip: HTMLDivElement) {
    const offset = tooltipHeight - hostRect.height;
    tooltip.style.top = `${(hostRect.y - offset / 2).toFixed(0)}px`;
    tooltip.style.left = `${(hostRect.x - this.tooltipWidth).toFixed(0)}px`;
  }
}
